import React, { ReactElement } from "react";

import _ from "lodash";
import { ConnectedProps, connect } from "react-redux";
import { AnyAction } from "redux";
import { ThunkDispatch } from "redux-thunk";

import { RootState } from "App/Store";

import * as constants from "Common/EVaultAppConstants";

import FilterBar from "Components/SearchBar/FilterBar";

import {
  initialQueueSearchBarParams,
  queueSearchParams,
  resetSearch,
  updateSearchBarParams,
} from "../Mers/Queue/QueueSlice";
import { executeSearch } from "../Mers/Queue/queuedLoansService";

const mapStateToProps = (state: RootState) => ({
  searchBarParams: state.queue.searchBarParams,
});

const connector = connect(mapStateToProps);

type TypesFromRedux = ConnectedProps<typeof connector>;

const searchCriteria = [
  ...constants.baseSearchCriteria,
  {
    name: "searchKey",
    options: [
      {
        apiParamValue: "mortgageIdentificationNumber",
        description: "MIN",
      },
    ],
    type: 0,
  },
];

export function QueueFilterBar(props: TypesFromRedux): ReactElement {
  const { searchBarParams, dispatch } = props;

  function handleReset() {
    dispatch(resetSearch());
  }

  function handleSubmit() {
    (dispatch as ThunkDispatch<any, undefined, AnyAction>)(executeSearch());
  }

  function handleCriteriaChange(value: queueSearchParams) {
    dispatch(updateSearchBarParams(value));
  }

  const displayResetButton = !_.isEqual(initialQueueSearchBarParams, searchBarParams);

  return (
    <FilterBar
      displayResetButton={displayResetButton}
      onCriteriaChange={handleCriteriaChange}
      onReset={handleReset}
      onSubmit={handleSubmit}
      searchCriterias={searchCriteria}
      searchParams={searchBarParams}
    />
  );
}

export default connector(QueueFilterBar);
